export enum InterchangeDuration {
  short = 'short',
  normal = 'normal',
}
